module.exports = __webpack_public_path__ + "img/home_banner_wrap6.9dc471d1.png";